// Google Material "light" chip palette — used for small stat cards inside
// colored banner headers across the dashboard pages. Kept to 8 entries so a
// row of chips on any single page can each get a distinct colour (no repeats).
// `bg` is the mid-tone fill used for banner/chip backgrounds; `bgLight` is a
// paler tint of the same hue for surfaces (like the KPI cards) that want a
// lighter background while keeping the same saturated text/border for contrast.
export const GOOGLE_LIGHT = [
  { bg: "#AECBFA", bgLight: "#E8F0FE", text: "#0B3D91", border: "#7BA8F5" }, // blue
  { bg: "#A8DAB5", bgLight: "#E6F4EA", text: "#0B4D26", border: "#77C08A" }, // green
  { bg: "#FDE293", bgLight: "#FEF7E0", text: "#7A4E00", border: "#F9C846" }, // yellow
  { bg: "#F6AEA9", bgLight: "#FCE8E6", text: "#8E1A16", border: "#EE756E" }, // red
  { bg: "#D7B9F7", bgLight: "#F3E8FD", text: "#5B1E96", border: "#B981F0" }, // purple
  { bg: "#A0E1EE", bgLight: "#E4F7FB", text: "#0B5F73", border: "#5FC7DC" }, // teal
  { bg: "#FBCBA3", bgLight: "#FEEFE3", text: "#7A3103", border: "#F5A461" }, // orange
  { bg: "#F7BBDD", bgLight: "#FCE7F3", text: "#821A54", border: "#EE85BC" }, // pink
];

// Cycles through GOOGLE_LIGHT by index so a row of N chips (N <= 8) never
// repeats a colour on the same page.
export const googleColor = (i) => GOOGLE_LIGHT[i % GOOGLE_LIGHT.length];

// "#RRGGBB" -> "rgba(r,g,b,alpha)" — used to soften chip/card fills to ~80% opacity.
export const withOpacity = (hex, alpha = 0.8) => {
  const n = parseInt(hex.slice(1), 16);
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
